import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import PETRAStore from './petra/'

export default new Vuex.Store({
  state: {
    dateFormatOptions: {
      'year': 'numeric',
      'month': 'numeric',
      'day': 'numeric'
    },
    user: {}
  },
  getters: {
    getRoles (state) {
      return typeof state.user.idToken !== 'undefined' && typeof state.user.idToken.roles !== 'undefined' ? state.user.idToken.roles : []
    },
    isAdmin (state) {
      return typeof state.user.idToken !== 'undefined' && typeof state.user.idToken.roles !== 'undefined' && state.user.idToken.roles.indexOf('Admin') >= 0
    }
  },
  mutations: {
    USER: (state, user) => {
      state.user = user
    }
  },
  actions: {
    setUser (context, user) {
      context.commit('USER', user)
    }
  },
  modules: {
    petra: PETRAStore
  }
})